module.exports = __webpack_public_path__ + "img/suitcase icon_1.bc76d53d.svg";